#!/usr/bin/env node
import { main } from "./index.js";

await main();
